import * as Yup from 'yup';

export const initialValuesFrameForm = {
    modelNumber: '',
    supplierId: '',
    supplierName: '',
    sku: '',
    supplierUpc: '',
    internalUpc: '',
    brand: '',
    brandId: '',
    catalogProductId: null,  // Catalog reference
    location: '',
    type: 'frame',
    isTaxable: false,
    defaultTaxPercentage: '0.00',
    supplierCost: '',
    landingCost: '',
    listPrice: '',
    properties: {
        eyeSize: '',
        bridgeSize: '',
        templeLength: '',
        aMeasurement: '',
        bMeasurement: '',
        dblMeasurement: '',
        edMeasurement: '',
        circumference: '',
        edAngle: '',
        frameColor: '',
        frameColorCode: '',
        lensColor: '',
        lensColorCode: '',
        material: '',
        shape: '',
        gender: '',
        rimType: '',
        ageGroup: '',
        frameType: '',
        color: '',
    },
    markupMultiplier: '1.0',
    profit: '',
    profitPercentage: '',
    lastOrdered: '',
    lastReceived: '',
    lastSold: '',
    totalSold: '',
    returned: '',
    quantityOnOrder: '',
    quantityOnHand: '',
    status: 'active',
    notes: '',
    photos: ''
};

const frameValidationSchema = Yup.object({
    modelNumber: Yup.string().required('Model number is required'),
    location: Yup.mixed().required('Location is required'),
    
    // Supplier is optional if from catalog, but if provided must be valid
    supplierName: Yup.string().when('catalogProductId', {
        is: (val) => !val, // If NOT from catalog
        then: (schema) => schema.required('Supplier is required for manual entries'),
        otherwise: (schema) => schema.notRequired()
    }),
    
    // Brand is optional if from catalog (auto-populated), required for manual entries
    brand: Yup.string().when('catalogProductId', {
        is: (val) => !val, // If NOT from catalog
        then: (schema) => schema.required('Brand is required for manual entries'),
        otherwise: (schema) => schema.notRequired()
    }),
    
    supplierCost: Yup.number()
        .min(0, 'Supplier cost must be a non-negative number')
        .integer('Supplier cost must be an integer'),
    landingCost: Yup.number().min(0, 'Landing cost must be a non-negative number'),
    listPrice: Yup.number()
        .min(0, 'List price must be a non-negative number')
        .required('List price is required'),
    photos: Yup.mixed()
});

export default frameValidationSchema;